<template>
  <div class="nav-box" :class="{ desktop: isDesktop }">
    <div class="code-box">
      <div class="nav-title">
        <div class="nav-left">
          <template v-if="!isLocal">
            <svg class="icon-home icon-svg" @click="returnHome">
              <use xlink:href="#icon-home" />
            </svg>
          </template>
        </div>
        <div class="nav-right">
          <a-tooltip title="思维导图" @click="showMind = true">
            <svg class="icon-svg">
              <use xlink:href="#icon-mind-map" />
            </svg>
          </a-tooltip>
          <a-tooltip title="资源库目录" @click="$emit('openResourceOutline')">
            <svg class="icon-svg">
              <use xlink:href="#icon-box" />
            </svg>
          </a-tooltip>
          <a-tooltip @click="swichNavMax()" v-if="showNav">
            <template #title>{{ navMax ? '解除固定' : '固定菜单' }}</template>
            <svg class="icon-svg icon-fold" :class="{ fixed: navMax }">
              <use xlink:href="#icon-fixed" />
            </svg>
          </a-tooltip>

          <div class="menu-grade">
            <a-tooltip title="显示大纲级别">
              <svg class="icon-svg" @click="openShowGradeMenu">
                <use xlink:href="#icon-catalog-menu" />
              </svg>
            </a-tooltip>
            <div class="grade-list" v-if="showGradeMenu">
              <div class="grade-item" v-for="(item, i) in menuGrade" :key="item.value" @click="chooseMenuGrade(i)">
                <span>{{ item.name }}</span>
                <a-switch :checked="item.show" :disabled="item.disabled" size="small" />
              </div>
            </div>
          </div>

          <a-tooltip title="关闭菜单" @click="foldNav()">
            <svg class="icon-svg popup-close">
              <use xlink:href="#icon-close" />
            </svg>
          </a-tooltip>
        </div>
      </div>
      <div class="book-title ellipsis">{{ currentClass?.ClassName }}</div>
      <div class="int-list">
        <div class="int-item-box" v-for="(int, i) in intList">
          <div class="int-part" v-if="int.Part">{{ int.Part }}</div>
          <div class="int-item" :data-id="int.PK_InductionGuid">
            <div class="int-title" :class="{ flash: int.flash }">
              <svg class="icon-svg icon-xiala" :class="{ isFold: int.isFold }" @click="foldNavItem(int)">
                <use xlink:href="#icon-xiala" />
              </svg>
              <span class="ellipsis" @click="switchChapter(i)">{{ int.InductionName }}</span>
            </div>
            <div class="cint-list" :class="{ 'fadeIn': !int.isFold, 'foldIn': int.isFold }" v-if="allOutline[i]">
              <div class="nav-item" :class="[{ flash: oitem.flash }, 'h' + oitem.level]"
                v-for="oitem in allOutline[i].children" @click="chooseChildNav(oitem, int.PK_InductionGuid)">{{
                  oitem.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Mindmap :outline="allOutline" :title="currentClass.ClassName" :bookId="currentIntId"
      :defaultActiveId="mindmapActiveInduction" @recordJump="data => $emit('recordJump', data)"
      @scrollToOutline="$event => $emit('scrollToOutline', $event)" @close="showMind = false" v-if="showMind"></Mindmap>
  </div>
</template>

<script>
import { LoadingOutlined } from '@ant-design/icons-vue';
import Mindmap from './Mindmap.vue';

export default {
  name: 'textbook-nav',
  components: {
    LoadingOutlined, Mindmap
  },
  props: {
    chapter_num: Number,
  },
  data() {
    return {
      intList: [],
      allOutline: [],

      menuGrade: [
        { name: '1级', value: 'h0', show: true, disabled: true },
        { name: '2级', value: 'h1', show: true },
        { name: '3级', value: 'h2', show: true },
        { name: '4级', value: 'h3', show: true },
        { name: '5级', value: 'h4', show: false },
        { name: '6级', value: 'h5', show: false },
        { name: '7级', value: 'h6', show: false },
      ],
      showMenuGrade: 'h3',
      showGradeMenu: false,

      navMax: false,
      showNav: true,
      userInfo: null,

      currentClass: null,
      isSharer: false,

      isDesktop: false,
      isLocal: false,

      showMind: false,
      mindmapActiveInduction: '',

      returnUrl: ''
    }
  },
  computed: {
    currentIntId() {
      const int = this.intList[this.chapter_num]
      return int ? int.PK_InductionGuid : ''
    },
  },
  mounted() {
    const { returnUrl } = this.$route.query;
    if (returnUrl) this.returnUrl = returnUrl;
    // //去掉地址栏参数
    // this.$router.replace({ query: {} });

    const { intList, userInfo, isSharer, currentClass, isLocal } = this.$store.state;
    this.intList = intList;
    this.userInfo = userInfo;
    this.isSharer = isSharer;
    this.currentClass = currentClass;
    this.isLocal = isLocal;
    this.isDesktop = !!(window && window.process && window.process.type);

    this.setMindmap();

    const debounce = this.debounce(this.setHeight, 100);
    window.addEventListener('resize', debounce);
  },
  methods: {
    openMindmap(inductionId) {
      this.mindmapActiveInduction = inductionId
      this.showMind = true
    },

    //设置各互动高度
    setHeight() {
      const wWidth = window.innerWidth;
      if (wWidth < 1000) {
        this.showNav = false;
        if (this.navMax) this.swichNavMax();
      } else this.showNav = true;
    },
    //选择章节
    switchChapter(i) {
      const int = this.intList[i];
      int.flash = true;
      setTimeout(() => { int.flash = false }, 200);

      this.$emit('switchChapter', i);
    },
    //折叠
    swichNavMax() {
      this.navMax = !this.navMax;
      this.$emit('swichNavMax', this.navMax);
    },
    //关闭
    foldNav() {
      this.navMax = false;
      this.$emit('swichNavMax', this.navMax);
      this.$emit('foldNav', true)
    },

    foldNavItem(int) {
      int.isFold = !int.isFold;
      if (!int.isFold && !this.menuGrade[1].show) {
        this.chooseMenuGrade(1)
      }

      int.flash = true;
      setTimeout(() => { int.flash = false }, 200);
    },
    //跳转首页
    returnHome() {
      if (this.returnUrl) window.location.href = this.returnUrl;
      else window.location.href = 'https://yuanxi.online';
    },
    //设置大纲级别
    setMindmap() {
      let allOutline = []
      this.intList.forEach(item => {
        let outline = {
          id: item.PK_InductionGuid,
          title: item.InductionName,
          children: []
        }

        let children = [];
        if (item.showTextbookContent) {
          let content = item.showTextbookContent;
          let dom = document.createElement('div');
          dom.innerHTML = content;
          //按照content标签顺序获取
          let showGrade = [];
          this.menuGrade.forEach(grade => {
            if (grade.show) showGrade.push(grade.value);
          })
          if (showGrade.length > 0) {
            let showGradeString = showGrade.join(',');
            let headers = dom.querySelectorAll(showGradeString);
            headers.forEach(h => {
              let level = h.tagName.toLowerCase().replace('h', '');
              let content = h.innerText;
              children.push({
                level,
                content,
                id: h.getAttribute('nav-data-id'),
              })
            })
          }
        }
        outline.children = children;
        allOutline.push(outline);
      })

      this.allOutline = allOutline;
      this.showMind = false;
    },

    //防抖
    debounce(fn, delay) {
      let timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn();
        }, delay);
      }
    },
    //点击了TextContent
    chooseChildNav(oitem, intId) {
      oitem.flash = true;
      setTimeout(() => {
        oitem.flash = false;
      }, 200);

      this.$emit('chooseChildNav', {
        intId,
        id: oitem.id
      })
    },

    //打开大纲级别菜单
    openShowGradeMenu() {
      this.showGradeMenu = !this.showGradeMenu;

      document.removeEventListener('click', this.handleClickOutside);
      if (this.showGradeMenu) {
        setTimeout(() => {
          document.addEventListener('click', this.handleClickOutside);
        }, 300);
      }
    },
    async handleClickOutside(event) {
      const popupElement = this.$el.querySelector('.grade-list');
      if (popupElement && !popupElement.contains(event.target)) {
        this.showGradeMenu = false;
      }
    },
    //选择大纲级别
    chooseMenuGrade(i) {
      //打开把上级别的都打开
      const item = this.menuGrade[i];
      if (item.disabled) return;

      if (!item.show) {
        for (let j = 0; j <= i; j++) {
          this.menuGrade[j].show = true;
        }
      }
      else {
        for (let j = i; j < this.menuGrade.length; j++) {
          this.menuGrade[j].show = false;
        }
      }

      this.setMindmap();
    },
    //正在选择大纲级别
    gradeVisible(event) {
      this.$emit('gradeChange', event)
    },
  },
  //组件销毁
  beforeUnmount() {
    const debounce = this.debounce(this.setHeight, 100);
    window.removeEventListener('resize', debounce);
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped lang="scss">
@import "./textbook-nav.scss";
</style>